<template>
    <div>
        <div class="form-group">
            <div class="input-group inputs">
                <input  :id="id"/>
                <label class="control-label" :for="id" >{{title}}</label><i class="bar"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        name: "InputComponent",
        props:['title','id']
    }
</script>

<style>
    .inputs{

    }

</style>